import React from "react";
import { useNavigate } from "react-router-dom";

export default function ContactPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <button
        onClick={() => navigate(-1)}
        style={styles.backButton}
      >
        ← Back
      </button>

      <div style={styles.card}>
        <h1 style={styles.title}>Contact Us</h1>

        <p style={styles.text}>
          If you have questions, support requests, partnership inquiries,
          or feedback, contact us at:
        </p>

        <p style={styles.email}>
          support@askuniverse.app
        </p>

        <p style={styles.text}>
          We aim to respond within 24–48 hours.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #07122b 0%, #020816 100%)",
    color: "#fff",
    padding: "40px 20px",
  },

  backButton: {
    position: "fixed",
    top: "20px",
    left: "20px",
    background: "rgba(255,255,255,0.1)",
    border: "1px solid rgba(255,255,255,0.2)",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "12px",
    cursor: "pointer",
    zIndex: 999,
    backdropFilter: "blur(10px)",
  },

  card: {
    maxWidth: "900px",
    margin: "0 auto",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "20px",
    padding: "32px",
    lineHeight: 1.7,
    textAlign: "center",
  },

  title: {
    fontSize: "40px",
    marginBottom: "20px",
  },

  text: {
    fontSize: "18px",
    opacity: 0.9,
  },

  email: {
    fontSize: "20px",
    fontWeight: "bold",
    margin: "24px 0",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    lineHeight: 1.4,
  },
};
